/* eslint-disable react/prop-types */
import React from 'react';
import { Context } from '@front10/helpers/dist/Context';
import RadioSelect from '../../elements/RadioSelect';

const FlightTypeFilter = (props) => {
  const { translate } = React.useContext(Context);
  const { options, value } = props;

  const flightTypeOptions = React.useMemo(() => {
    return (Array.isArray(options) ? options : []).map((option) => ({
      ...option,
      name: translate(`cmp-journey-type-options-${option.label}`),
    }));
  }, [options, translate]);

  return (
    <RadioSelect
      {...props}
      options={flightTypeOptions}
      selectedOption={{ value }}
      dataTestId="flightTypeFilter"
      placeholder={translate('cmp-flight-type-placeholder', 'Select Flight Type')}
    />
  );
};

FlightTypeFilter.defaultProps = {
  options: [
    { label: 'rt', value: 'ROUND_TRIP' },
    { label: 'ow', value: 'ONE_WAY' },
  ],
};

export default FlightTypeFilter;
